import "core-js/modules/es.array.push.js";
import Cookie from 'js-cookie';
import { mapState } from 'vuex';
import { handleLocalStorage, routerJump, getTheme, setTheme } from '@/assets/js/utils.js';
const nodeUrl = require('url');
export default {
  data() {
    return {
      joinInfo: '',
      showJoinParty: false,
      timer: null,
      logoSvg: '',
      modelType: '',
      partyCode: ''
    };
  },
  setup() {
    const {
      isDark
    } = getTheme();
    return {
      isDark,
      getTheme,
      setTheme
    };
  },
  computed: {
    ...mapState({
      State: state => state,
      homeLogo: state => state.homeLogo,
      Config: state => state.config,
      CheckEnv: state => state.checkEnv
    })
  },
  async created() {
    const URL = nodeUrl.parse(location.href, true);
    this.modelType = URL.query.model;
    this.partyCode = URL.query.partyCode;
    document.title = this.$t('common.partylineJoin');
    this.role = handleLocalStorage('get', 'isHost');
    // 获取Producer版本号
    const that = this;
    this.serviceNameList = this.$store.state.config.serviceNames;
    if (this.role) {
      this.$backAndFrontVersion({
        ...this.$TVU,
        params: {
          serviceNameList: this.serviceNameList
        },
        success: function (val) {
          that.ProducerFrontendVersion = val[0].frontendVersion;
          that.ProducerBackendVersion = val[0].backendVersion;
          that.ProducerTagName = val[0].tagName;
        },
        error: function (val) {}
      });
    }
  },
  mounted() {
    this.logoSvg = `#${this.State.commonLogo}`;
    document.body.parentElement.className += ' scroll';
  },
  methods: {
    changeParticipantLanguage() {
      if (this.$i18n.locale === 'zh' || this.$i18n.locale === 'zh-CN') {
        Cookie.set('userLanguage', 'en', {
          domain: '.tvunetworks.com'
        });
        this.$i18n.locale = 'en';
        this.State.browserLanguage = 'en';
      } else {
        Cookie.set('userLanguage', 'zh', {
          domain: '.tvunetworks.com'
        });
        this.$i18n.locale = 'zh';
        this.State.browserLanguage = 'zh';
      }
    },
    async login() {
      // 判断用户登录了没有
      const hasLogin = await this.$store.dispatch('isLogin');
      if (hasLogin) {
        await this.$store.dispatch('checkEnv');
        const publicPath = this.State.publicPath || 'partyline';
        let hostUrl = `${location.protocol}//${location.host}/${publicPath}/manage`;
        if (this.modelType === 'station') {
          hostUrl = `${location.protocol}//${location.host}/${publicPath}/preview?id=${this.partyCode}`;
        }
        if (this.CheckEnv.updateEnv) {
          // 判断是否要更新环境
          window.location.href = hostUrl;
        } else {
          routerJump('manage');
        }
      } else {
        var _this$State$config$ur;
        const userServerUrl = (_this$State$config$ur = this.State.config.urlInfo) === null || _this$State$config$ur === void 0 ? void 0 : _this$State$config$ur.userservice;
        const publicPath = this.State.publicPath || 'partyline';
        let url = `${userServerUrl}/?url=${location.protocol}//${location.host}/${publicPath}/manage&serviceName=Partyline`;
        if (this.modelType === 'station') {
          url = `${userServerUrl}/?url=${location.protocol}//${location.host}/${publicPath}/preview&model=station&id=${this.partyCode}&serviceName=Partyline`;
        }
        window.location.href = url;
      }
    },
    showJoin() {
      this.showJoinParty = true;
    },
    joinParty() {
      var _this$Config;
      const url = this.joinInfo.replace(/\s+/g, '');
      const isCommentator = url.includes('commentator');
      let id = null;
      let additionalParams = {};
      const parseAdditionalParams = input => {
        const params = {};
        // 处理同时包含 ? 和 & 的情况
        const queryPart = input.includes('?') ? input.split('?')[1] || '' : input;

        // 将参数分割为键值对
        queryPart.split('&').forEach(pair => {
          const [key, value] = pair.split('=').map(item => item.trim());
          if (key) {
            params[key] = isNaN(Number(value)) ? value : Number(value);
          }
        });
        return params;
      };
      if (isNaN(Number(url))) {
        if (url.includes('join_id')) {
          if (url.includes('PartyID:')) {
            id = url.split('PartyID:')[1];
          } else {
            id = this.getQueryString(url, 'join_id');
          }
        } else if (url.includes('id=')) {
          id = this.getQueryString(url, 'id');
        } else {
          id = url.split('?')[0].split('&')[0];
        }
        additionalParams = parseAdditionalParams(url);
      } else {
        id = url;
      }
      if (!id) {
        this.$message.error(this.$t('remainWords.enterId'));
        return;
      }
      sessionStorage.removeItem('enterPartyType');
      const history = handleLocalStorage('get', 'historyList') ? JSON.parse(handleLocalStorage('get', 'historyList')) : '';
      if (!history || !history.length) {
        handleLocalStorage('set', 'historyList', JSON.stringify([{
          value: id
        }]));
      } else {
        let add = true;
        history.forEach(item => {
          if (item.value == id) add = false;
        });
        if (add) history.push({
          value: id
        });
        handleLocalStorage('set', 'historyList', JSON.stringify(history));
      }
      const query = {
        join_id: id,
        slotNum: additionalParams.slotNum,
        env: (_this$Config = this.Config) === null || _this$Config === void 0 ? void 0 : _this$Config.apiEnv,
        type: isCommentator ? 'commentator' : ''
      };
      routerJump('participate', query);
    },
    getQueryString(url, name) {
      let value = null;
      url = url.split('?')[1];
      if (url) {
        url = url.split('&');
        url.forEach(v => {
          const keysValue = v.split('=');
          if (keysValue[0] == name) {
            value = keysValue[1];
          }
        });
      }
      return value;
    },
    cancel() {
      this.showJoinParty = false;
    },
    getHistoryList(queryString, cb) {
      const history = handleLocalStorage('get', 'historyList') ? JSON.parse(handleLocalStorage('get', 'historyList')) : [];
      if (this.timer) clearTimeout(this.timer);
      if (history && history.length) {
        if (queryString) {
          this.timer = setTimeout(() => {
            const result = history.filter(item => {
              if (item.value.includes(queryString.replace(/\s+/g, ''))) {
                return this.$options.filters.returnStrByInfo(item.value);
              }
            });
            cb(result);
          }, 1000);
        } else {
          this.timer = setTimeout(() => {
            cb(history);
          }, 1000);
        }
      } else {
        const result = [];
        cb(result);
      }
    }
  }
};